module.exports = __webpack_public_path__ + "media/images/marketing/spiral-down-d8f23b1115a276878d70e5d4e01cdf355ae9127227b0b5975917694a42a5e367.png";